import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"

import { internalLink } from "~/services/helper"

import * as Styled from "./styled"

const scrollTop = (): number => {
  return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
}

const COMPANIES =
  "SONY｜Yahoo｜電通｜アクセンチュア｜三菱商事｜KDDI｜NTTドコモ｜アビーム・コンサルティング｜日立製作所｜楽天｜ソフトバンク｜住友商事｜ZOZO｜Sky｜キーエンス｜富士通｜丸紅｜ユーキャン｜"

export const LtiRegistrationLpPage: React.FC = () => {
  const router = useRouter()
  const [isTop, setIsTop] = useState(true)
  const [queryStrings, setQueryStrings] = useState("")

  useEffect(() => {
    document.addEventListener("scroll", onScroll)
    setQueryStrings(`${window.location.search}${window.location.search ? "&" : "?"}access_from=lti-registration-lp`)
    return () => document.removeEventListener("scroll", onScroll)
  }, [])

  const onScroll = () => {
    setIsTop(scrollTop() <= 450)
  }

  return (
    <>
      <Styled.Wrapper>
        <div className="floating-btn-wrap" style={{ opacity: isTop ? 0 : 1 }}>
          <button className="floating-btn" onClick={() => router.push(internalLink(`/auth/register${queryStrings}`))}>
            <span>＼カンタン1分登録／</span>無料会員登録はこちら
          </button>
        </div>

        <div className="kv-wrap">
          <div className="kv-logo">
            <a href="https://www.in-fra.jp/long-internship">
              <img src="/next/static/images/lti-registration-lp/logo.png" />
            </a>
          </div>
          <h1 className="kv-txt-main">
            長期・有給インターンは
            <br />
            Infra インターンで探そう
          </h1>
          <img
            className="kv-emblem"
            src="/next/static/images/lti-registration-lp/emblem.png"
            alt="主要長期インターンサイト 求人数No.1 & 利用企業数No.2"
          />
          <p className="kv-txt-read">
            Infra インターンは業界トップクラスの求人数を誇り、
            <br />
            登録するだけで企業からのスカウトや
            <br className="pcnone" />
            専属アドバイザーから求人紹介を受けることができる、
            <br />
            長期インターン特化型サービスです
          </p>
          <div className="kv-companies">
            <div className="kv-txt-ttl">
              就職内定先<sup>*2</sup>
            </div>
            <div className="kv-wrap-companies">
              <div className="kv-txt-companies">{COMPANIES + COMPANIES}</div>
            </div>
          </div>
          <div className="kv-txt-btn-shoulder">カンタン1分登録</div>
          <button className="kv-cv-btn" onClick={() => router.push(internalLink(`/auth/register${queryStrings}`))}>
            無料会員登録はこちら
          </button>
          <div className="kv-caution">
            ＊1：自社調べ 主要長期インターンサイト（2022年11月18日）
            <br />
            ＊2：Infra インターン経由で長期インターンに参加経験がある学生の就職活動における内定実績
          </div>
        </div>

        <div className="match-wrap">
          <div className="match-inner">
            <div className="match-ttl-shoulder">
              累計求人数<strong>500</strong>件以上！
            </div>
            <h2 className="match-txt-ttl">
              あなたに合う求人が
              <br className="pcnone" />
              きっと見つかる。
            </h2>
            <div className="match-cnt-wrap-type01">
              <h3 className="match-txt-sub-ttl">多種多様な業界のインターンを幅広く掲載</h3>
              <p className="match-txt-sub-read">
                就職活動でも人気の「IT」「商社」「コンサルティング」から「ブライダル」「ゲーム」など少しニッチな業界まで幅広い業界のインターンが掲載されています。あなたが実際に働いてみたい業界を選んで求人を探してみましょう。
              </p>
            </div>
            <div className="match-cnt-wrap-type02">
              <h3 className="match-txt-sub-ttl">あなたの条件にマッチした求人を探せる</h3>
              <p className="match-txt-sub-read">
                リモート勤務や土日出勤可能な求人など学業と両立しやすいインターンが多数掲載されています。また「未経験者歓迎」「社長直下」「高時給」など、あなたのこだわり条件にマッチしたインターンを見つけることができます。
              </p>
            </div>
          </div>
        </div>

        <div className="why-wrap">
          <div className="why-inner">
            <div className="why-ttl-catch">
              <span className="copy">Why?</span>
            </div>
            <h2 className="why-ttl">
              なぜ、Infra インターンが
              <br className="pcnone" />
              選ばれるのか。
            </h2>
            <div className="why-cnt-wrap">
              <div className="why-cnt-type01">
                <h3 className="why-cnt-ttl">
                  <span>
                    <strong>求人数</strong>
                    <br />
                    トップクラス
                  </span>
                </h3>
                <p className="why-cnt-read">
                  Infraに掲載されている求人数は業界トップクラス。幅広い業界だけではなく、職種やエリアなど様々な条件から自分が求めている条件に合った企業を探すことができます。
                </p>
              </div>
              <div className="why-cnt-type02">
                <h3 className="why-cnt-ttl">
                  <strong>成長</strong>環境
                </h3>
                <p className="why-cnt-read">
                  求人数が多いだけでなく、社長直下で新規事業を起こすインターンシップやブランドマネージャーとして責任を持って業務を任せてもらえるなど自分自信の価値を上げていける求人が多数掲載されています。
                </p>
              </div>
              <div className="why-cnt-type03">
                <h3 className="why-cnt-ttl">
                  <strong>徹底</strong>サポート
                </h3>
                <p className="why-cnt-read">
                  どのインターンが自分に合っているか分からない方向けの求人紹介サポートなど、求人への応募はもちろんのこと、インターンシップに参加した後の困り事もInfra事務局がサポートをしていきます。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="voice-wrap">
          <div className="voice-inner">
            <div className="voice-ttl-catch">
              <span className="copy">VOICE</span>
            </div>
            <h2 className="voice-ttl">
              <span>I</span>nfra インターン<span>体</span>験談
            </h2>
            <div className="voice-cnt-wrap">
              <div className="voice-cnt">
                <div className="voice-account-wrap">
                  <img src="/next/static/images/lti-registration-lp/thumb01.png" alt="サムネイル" />
                  <div className="voice-account-detail">
                    <div className="voice-university">東北大学 法学部 4年生</div>
                    <div className="voice-occupation">Webマーケティング</div>
                  </div>
                </div>
                <div className="voice-comment-wrap">
                  <h3 className="voice-comment-ttl">
                    「自分で考えて、利益を出す」
                    <br />
                    <strong>リアルなビジネス経験</strong>の先取り！
                  </h3>
                  <p className="voice-comment">
                    スキルを伸ばすためと給料をもらえるからという理由で長期・有給インターンを始めました。
                    <br />
                    自分で市場を読み、出した広告が利益を生み出したときが楽しいと感じる瞬間です。トライ&amp;エラーを繰り返すことで、自分の仮説検証力が高まったと思っています。結果がすぐに認識できて、直に実力がついたことがわかったことも嬉しかったです。
                  </p>
                </div>
              </div>
              <div className="voice-cnt">
                <div className="voice-account-wrap">
                  <img src="/next/static/images/lti-registration-lp/thumb03.png" alt="サムネイル" />
                  <div className="voice-account-detail">
                    <div className="voice-university">京都産業大学大学院 先端情報学研究科 1年生</div>
                    <div className="voice-occupation">エンジニア</div>
                  </div>
                </div>
                <div className="voice-comment-wrap">
                  <h3 className="voice-comment-ttl">
                    <strong>フルリモート</strong>でインターン。初めて<strong>実務でコードを書き</strong>経験値アップ！
                  </h3>
                  <p className="voice-comment">
                    実際の業務をしてみたいと思い、インターンを始めました。フルリモートで業務ができることもスタートを決めた要因です。
                    <br />
                    実務でコードを書くのが初めてなので、日々分からないことを調べて動かしてみる作業を繰り返しています。自分が作ったものが何か機能として意味を持ち、Web上で想定通りに動いているのを見ると達成感が出て嬉しい気持ちになります。
                  </p>
                </div>
              </div>
              <div className="voice-cnt">
                <div className="voice-account-wrap">
                  <img src="/next/static/images/lti-registration-lp/thumb02.png" alt="サムネイル" />
                  <div className="voice-account-detail">
                    <div className="voice-university">早稲田大学 国際教養学部 1年生</div>
                    <div className="voice-occupation">営業事務</div>
                  </div>
                </div>
                <div className="voice-comment-wrap">
                  <h3 className="voice-comment-ttl">
                    不安の中でスタート！<strong>しっかりとした研修と仲間</strong>がいるから未経験でも安心。
                  </h3>
                  <p className="voice-comment">
                    就活に役立てたいからという気持ちとスキルを身に付けるために長期インターンをスタートしました。
                    <br />
                    自由度が高く裁量権が大きいこと、インターン生のレベルが高いこと、そして初期研修が充実していることが今のインターン先の特徴です。まだまだなところも多いので、早く先輩に追いつき、会社に貢献できる一人前のインターン生になりたいと思っています。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="support-wrap">
          <div className="support-inner">
            <div className="support-ttl-catch">
              <span className="copy">SUPPORT</span>
            </div>
            <h2 className="support-ttl">
              長期インターンへの参加を
              <br className="pcnone" />
              3段階でサポート
            </h2>
            <div className="support-cnt-wrap">
              <div className="support-cnt">
                <h3>
                  <div className="support-cnt-ttl-catch">SUPPORT</div>
                  <div className="support-cnt-ttl-number">01</div>
                  <div className="support-cnt-ttl">求人紹介</div>
                </h3>
                <p className="support-cnt-detail">
                  長期インターンをしたいと言っても、どんな業務をしたいか、どれくらい働きたいかは人によって違います。
                  <br />
                  <strong>500求人を超える中から、一人ひとりに合った求人の紹介サービス</strong>を行っています。
                </p>
              </div>
              <div className="support-cnt">
                <h3>
                  <div className="support-cnt-ttl-catch">SUPPORT</div>
                  <div className="support-cnt-ttl-number">02</div>
                  <div className="support-cnt-ttl">選考フォロー</div>
                </h3>
                <p className="support-cnt-detail">
                  求人に応募した後も、志望動機を作り、面接したりとやることはたくさん。
                  <br />
                  選考に対するサポートもしながら、<strong>合格までしっかりと伴走</strong>させていただきます。
                </p>
              </div>
              <div className="support-cnt">
                <h3>
                  <div className="support-cnt-ttl-catch">SUPPORT</div>
                  <div className="support-cnt-ttl-number">03</div>
                  <div className="support-cnt-ttl">内定後フォロー</div>
                </h3>
                <p className="support-cnt-detail">
                  インターンシップを
                  <strong>スタートした後も困り事や悩みがあれば、気軽にご相談をお受け</strong>
                  いたします。当社内に社労士資格を持った専門家もいるので、労働についても気軽にご相談ください。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="faq-closing-wrap">
          <div className="faq-wrap">
            <div className="faq-ttl-catch">
              <span className="copy">FAQ</span>
            </div>
            <h2 className="faq-ttl">
              よくある<span>質</span>問
            </h2>
            <dl>
              <dt className="faq-question">
                <span>Q</span>アルバイトと長期インターンシップでは何が違うのでしょうか？
              </dt>
              <dd className="faq-answer">
                インターンとアルバイトは「働いて、対価（お給料）をもらう」という意味では似ていますが、そもそも全く異なる概念です。アルバイトは本業や学業のかたわら、収入を得るための仕事をすること。一方でインターンは、「学生が自己の適性を把握する、あるいは仕事の内容を理解するために、在学中に一定期間に企業内で就業体験を行うこと」を意味します。また雇う企業側が新卒採用を意識してインターン採用している場合もあります。
              </dd>
              <dt className="faq-question">
                <span>Q</span>目安となる勤務時間はどれくらいでしょうか？
              </dt>
              <dd className="faq-answer">
                平日週3日12時間程度からの長期インターン先をメインで紹介しております。インターンシップに入れる時間が多いほど、裁量権のある仕事を任せられることが多いため、深い経験を得ることができます。企業によっては土日もOKというところもあります。心配な場合はサポーターへ相談してみてください。
              </dd>
              <dt className="faq-question">
                <span>Q</span>長期インターンに興味はあるのですが、時間に余裕がありません。
              </dt>
              <dd className="faq-answer">
                就職活動やアルバイト、授業など忙しい日々を送っている方もいましたが、アルバイトの稼働を少なくして、有給インターンに参加したり、業界研究の時間よりもまずは自分の能力を磨くべきと長期インターンに時間を使おうという意思決定をしてくれた人も少なくありません。自分なりに優先順位を立てて、何に時間を使うのかを決めてみてください。
              </dd>
            </dl>
          </div>
          <div className="closing-wrap">
            <p className="closing-message">
              今から始めよう。
              <br />
              あなたのキャリアを、
              <br />
              一歩前へ。
            </p>
          </div>
        </div>
      </Styled.Wrapper>
    </>
  )
}
